// extracted by mini-css-extract-plugin
export default {"IssueBodyLoadingContainer":"IssueBodyLoading-module__IssueBodyLoadingContainer--beSXm"};